// This doesn't seem to be doing anything extra.
// (tested on Safari mobile 12.x)
// Consult with @dtuzisnky (original author) before removal.

const SafariDoubleTapFix = () => {
  // fix double tap needed on safari links with
  // pseudo elements like our progressborder on buttons
  const events = 'click touchend'.split(' ');
  const links = document.querySelectorAll('a[href]');
  links.forEach(link => {
    events.forEach(eventName => () => {
      link.addEventListener(eventName, e => {
        window.location = e.target.href;
      });
    });
  });
};

export default SafariDoubleTapFix;



// WEBPACK FOOTER //
// ./src/scripts/modules/SafariDoubleTapFix.js